<div class="mycanvas" *ngIf="showSpinner">
  <div class="ball1"></div>
  <div class="shadow1"></div>
  <div class="ball2"></div>
  <div class="shadow2"></div>
  <div class="ball3"></div>
  <div class="shadow3"></div>
</div>
